import { render } from "./FlowSettingsBulk.vue?vue&type=template&id=0aa7801c&scoped=true"
import script from "./FlowSettingsBulk.vue?vue&type=script&lang=ts"
export * from "./FlowSettingsBulk.vue?vue&type=script&lang=ts"

import "./FlowSettingsBulk.vue?vue&type=style&index=0&id=0aa7801c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0aa7801c"

export default script